<template>
    <div>
        <app-sub-title text="Comunicaciones"></app-sub-title>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    data: () => ({}),
    computed: {},
    methods: {},
}
</script>
